export default __webpack_public_path__ + "static/media/forward-pay.7027a1bd.webp";